import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=03da5996&scoped=true"
import script from "./Manufacturers.vue?vue&type=script&lang=js"
export * from "./Manufacturers.vue?vue&type=script&lang=js"
import style0 from "./Manufacturers.vue?vue&type=style&index=0&id=03da5996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da5996",
  null
  
)

export default component.exports